import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AcessoTermosPav { token: string; url: string; }

/** Acesso de 1 h à página de termos do pav, gerado pelo back para o operador logado. */
@Injectable({ providedIn: 'root' })
export class TermosPavService {
  private readonly apiURL = `${environment.apiUrl}/v${environment.apiVersion}/termos-pav`;

  constructor(private http: HttpClient) {}

  async acesso(): Promise<AcessoTermosPav> {
    try {
      const r: any = await firstValueFrom(this.http.get<any>(`${this.apiURL}/acesso`));
      const a = r?.data?.[0];
      if (!a?.token || !a?.url) throw new Error();
      return { token: a.token, url: a.url };
    } catch (e: any) {
      const msg = e?.error?.notifications?.[0]?.message;
      throw new Error(e?.status === 0 ? 'Sem conexão com o servidor. Tente de novo.' : msg || 'Não foi possível abrir os termos agora.');
    }
  }
}

export interface ParametrosTermos {
  marca: string;
  cdPessoaFisica?: string | number | null;
  superficie?: 'fila';
  tema?: 'claro' | 'escuro';
  acao?: string | null;
}

/** Sem paciente o embed abre na busca. */
export function urlDosTermos(acesso: AcessoTermosPav, p: ParametrosTermos): string {
  const qs = new URLSearchParams({ token: acesso.token });
  if (p.cdPessoaFisica != null && p.cdPessoaFisica !== '') qs.set('cdPessoaFisica', String(p.cdPessoaFisica));
  qs.set('marca', p.marca);
  if (p.superficie) qs.set('superficie', p.superficie);
  if (p.tema) qs.set('tema', p.tema);
  if (p.acao) qs.set('acao', p.acao);
  return `${acesso.url}/termos-embed-fila.html?${qs.toString()}`;
}
